// frontend/src/pages/Perfil.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PerfilPessoal from './PerfilPessoal';
import PerfilPublico from './PerfilPublico';

export default function Perfil() {
  const { id } = useParams();
  const { usuario } = useAuth();

  // Se não tem :id -> /perfil (meu perfil)
  // Se :id é meu uid -> ainda é meu perfil
  if (!id || id === usuario?.uid) return <PerfilPessoal />;

  // Perfil público de outro usuário
  return <PerfilPublico id={id} />;
}
